module.exports = __webpack_public_path__ + "static/media/S (174).242cc70c.jpg";